export function getItems(search_term, assignees) {
  return !search_term ? assignees : []
}
